import { combineReducers } from "redux";
import { clone } from "lodash";
import { Action } from "../../index";
import { ADD_MESSAGE_ENTITIES, ADD_MESSAGE_ENTITY, MessageEntityPayload, MessageEntitiesPayload, addMessageEntitiesPosition } from "../messages/messages";
import { MARK_CHAT_AS_READ_SUCESS } from "../appChats/appChats";
import { IChatNormalized, IChatsNormalizedById } from "../../../types/index";

import API from "../../../vendor/api";
API.transportMethod = "WS";

import { IChatDetails } from "../../../types";

/**
 * Actions
 */

export const ADD_CHAT_ENTITIES = "meumedico/chats/ADD_CHAT_ENTITIES";
export function addChatEntities(chats: IChatNormalized) {
    return {
        type: ADD_CHAT_ENTITIES,
        payload: {
            chats
        }
    };
};

export const ADD_CHAT_ENTITY = "meumedico/chats/ADD_CHAT_ENTITY";
export function addChatEntity(chat: IChatNormalized) {
    return {
        type: ADD_CHAT_ENTITY,
        payload: {
            chat
        }
    };
};

// Reducer
export interface ChatState {
    allIds: string[];
    byId: IChatsNormalizedById;
};

const INITIAL_STATE: ChatState = {
    allIds: [],
    byId: {}
};

interface IChatEntitiesPayload {
    chats: IChatDetails[];
};

interface IChatEntityPayload {
    chat: IChatNormalized;
}

interface IMarkAsReadPayload {
    chatId: string;
}

function chatsById(state: any = INITIAL_STATE.byId, action: Action<IChatEntitiesPayload & MessageEntityPayload & MessageEntitiesPayload & IMarkAsReadPayload & IChatEntityPayload>) {
    switch(action.type) {
        case ADD_CHAT_ENTITIES:
            return (() => {
                let chats: IChatsNormalizedById = Object.assign({}, state);
                let receivedChats: IChatsNormalizedById = Object.assign({}, action.payload.chats);
                Object.keys(receivedChats).map(chat => {
                    let chatObj = receivedChats[chat];
                    let lastMessageIndex = chatObj.messages.length - 1;
                    chats[chat] = Object.assign({}, chatObj, {
                        lastMessageId: chatObj.messages[lastMessageIndex],
                        firstMessageId: chatObj.messages[0]
                    });
                });
                return chats;
            })();
        case ADD_MESSAGE_ENTITIES:
            return (() => {
                if (!action.payload.messages) {
                    return state;
                }

                const chatId = action.payload.chatId;
                const newMessageIds = Object.keys(action.payload.messages) || [];

                if (newMessageIds.length < 1) {
                    return state;
                }

                let chats: IChatsNormalizedById = Object.assign({}, state);
                let assignObj = {};

                if (action.payload.position === addMessageEntitiesPosition.Append) {
                    assignObj = {
                        messages: chats[chatId].messages.concat(newMessageIds),
                        lastMessageId: newMessageIds[newMessageIds.length - 1]
                    };
                } else if (action.payload.position === addMessageEntitiesPosition.Prepend) {
                     assignObj = {
                         messages: newMessageIds.concat(chats[chatId].messages),
                         firstMessageId: action.payload.messages[newMessageIds[0]].id
                     };
                }

                chats[chatId] = Object.assign({}, chats[chatId], assignObj);

                return chats;
            })();
        case ADD_CHAT_ENTITY:
            return (() => {
                const chat = action.payload.chat;
                let chats: IChatsNormalizedById = Object.assign({}, state);
                if (chats[chat.id]) {
                    return chats;
                }
                chats[chat.id] = chat;
                return chats;
            })();
        case ADD_MESSAGE_ENTITY:
            return (() => {
                let chats: IChatsNormalizedById = Object.assign({}, state);

                const message = action.payload.message;
                const chatId = message.chat_id;
                const currentUserId = action.payload.currentUserId;
                const currentChatId = action.payload.currentChatId;

                // console.log("teste5", message.chat_id, action.payload);

                let incrementUnreadCounter = (
                    message.chat_id !== currentChatId &&
                    message.sender_id !== currentUserId &&
                    chats[chatId].messages.indexOf(message.id) === -1
                );

                console.log({chats: chats[chatId]});

                chats[chatId] = Object.assign({}, chats[chatId], {
                    messages: chats[chatId].messages.concat(message.id),
                    lastMessageId: message.id,
                    unread_count: (state[chatId].unread_count || 0) + (incrementUnreadCounter ? 1 : 0)
                });

                return chats;
            })();
        case MARK_CHAT_AS_READ_SUCESS:
            return (() => {
                const chatId = action.payload.chatId;
                let chats: IChatsNormalizedById = Object.assign({}, state);
                chats[chatId].unread_count = 0;
                return chats;
            })();
        default:
            return state;
    }
}

function allChats(state: any = INITIAL_STATE.allIds, action: Action<any>) {
    switch(action.type) {
        case ADD_CHAT_ENTITIES:
            return Object.keys(action.payload.chats).map((entity: any) => {
                return entity;
            });
        case ADD_MESSAGE_ENTITY:
            return (() => {
                const chatId = action.payload.message.chat_id;
                const chats = clone(state);
                const index = state.indexOf(chatId);
                if (index > -1) {
                    // console.log("teste");
                    // console.log(state, chatId, index);
                    // console.log(state.splice(index, 1));
                    chats.splice(index, 1);
                    chats.unshift(chatId);
                    return chats;
                }

                return state;
            })();
        case ADD_CHAT_ENTITY:
            return (() => {
                const chat = action.payload.chat;
                const chats = clone(state);
                if (chats.indexOf(chat.id) !== -1) {
                    return chats;
                }
                return chats.concat(chat.id);
            })();
        default:
            return state;
    }
}

const chatsReducer = combineReducers({
    byId : chatsById,
    allIds : allChats
});

export default chatsReducer;



// WEBPACK FOOTER //
// ./src/redux/modules/chats/chats.tsx